/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

// Importación de módulos y componentes necesarios
import { useState, useEffect, useCallback } from 'react';
import { format } from 'date-fns';
import {
  TextField,
  InputAdornment,
  Modal,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Switch,
  Paper,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Box,
} from '@mui/material';
import { Search as SearchIcon, Add as AddIcon } from '@mui/icons-material';
import Swal from 'sweetalert2';
import useStyles from './styles';
import editarImage from '../../../../images/editar.png';
import eliminarImage from '../../../../images/eliminar.png';
import { clientAxios8080 } from '../../../../configs/axios';
import LoadingOverlay from "../../../loading-overlay";

function EntidadDetalle() {
  const classes = useStyles();

  const [loading, setLoading] = useState(true);
  const [entidades, setEntidades] = useState([]); // Inicializar con un array vacío
  const [regiones, setRegiones] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalEntidadId, setModalEntidadId] = useState(null);
  const [modalRegionId, setModalRegionId] = useState(null);
  const [modalNombre, setModalNombre] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [nombreError, setNombreError] = useState('');
  const [regionIdError, setRegionIdError] = useState('');
  const [modalFechaCreacion, setModalFechaCreacion] = useState('');
  const [modalStatus, setModalStatus] = useState(true);
  const [filteredRegiones, SetFilteredEntidades] = useState([]); // Nuevo estado para almacenar los resultados filtrados
  const [modalRegionIdSelect, setModalRegionIdSelect] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const formattedDate = new Date().toISOString();

  const modalStyle = {
    position: 'absolute',
    width: '50%',
    bgcolor: 'background.paper',
    // boxShadow: theme.shadows[5],
    // padding: theme.spacing(4),
    p: 4,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  async function getRegion() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/region');
      const responseData = response.data.data.filter((region) => region.status === true);
      setRegiones(responseData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function getEntidad() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/entidad');
      const responseData = response.data.data;
      responseData.sort((a, b) => a.entidadId - b.entidadId);
      setEntidades(responseData);
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.error('Error fetching data:', error);
    }
  }

  const postEntidad = async () => {
    try {
      const newEntidadData = {
        dsEntidad: modalNombre,
        entidadId: modalEntidadId,
        fechaCreacion: formattedDate,
        region: {
          regionId: modalRegionIdSelect,
        },
        status: modalStatus,
      };

      const response = await clientAxios8080.post('/ms-catalogos/filtros/entidad', newEntidadData);
      console.log('Datos que se enviarán en la solicitud POST:', newEntidadData); // Agrega esto a postEntidad

      if (response.status === 200) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Registro creado con éxito',
          showConfirmButton: false,
          timer: 1200,
        });
        getEntidad();
      } else {
        setLoading(false)
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al procesar la solicitud',
          text: response.data.error || 'Hubo un error al procesar la solicitud.',
        });
      }
    } catch (error) {
      setLoading(false)
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al procesar la solicitud',
        text: error || 'Hubo un error al procesar la solicitud.',
      });
    }
  };

  const putEntidad = async () => {
    try {
      const updatedEntidadData = {
        dsEntidad: modalNombre,
        entidadId: modalEntidadId,
        fechaCreacion: formattedDate,
        region: {
          regionId: modalRegionIdSelect,
        },
        status: modalStatus,
      };

      const response = await clientAxios8080.put(`/ms-catalogos/filtros/entidad/`, updatedEntidadData);
      if (response.status === 200) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Registro creado con éxito',
          showConfirmButton: false,
          timer: 1200,
        });
        getEntidad();
      } else {
        setLoading(false)
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al procesar la solicitud',
          text: response.data.error || 'Hubo un error al procesar la solicitud.',
        });
      }
    } catch (error) {
      setLoading(false)
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al procesar la solicitud',
        text: error || 'Hubo un error al procesar la solicitud.',
      });
    }
  };

  const deleteEntidad = async (entidadId) => {
    setLoading(true)
    try {
      const response = await clientAxios8080.delete(`/ms-catalogos/filtros/entidad?id=${entidadId}`);

      if (response.status === 200) {
        getEntidad();
      } else {
        console.error('Error al eliminar la entidad:', response.data.error);
      }
    } catch (error) {
      console.error('Error al enviar la solicitud DELETE:', error);
    }
  };

  useEffect(() => {
    getEntidad();
    getRegion();
  }, []);

  // Maneja el clic en el botón "Agregar Nuevo"
  const handleAgregarClick = () => {
    setIsModalOpen(true);
    setModalEntidadId(null);
    setModalNombre('');
    setModalRegionIdSelect('');
    setModalRegionId(null);
    setModalFechaCreacion(formattedDate);
    setModalStatus(true);
  };

  // Maneja el clic en el botón "Editar"
  const handleEditarClick = (entidadId, nombre, status, regionId, fechaCreacion) => {
    setIsModalOpen(true);
    setModalEntidadId(entidadId);
    setModalNombre(nombre);
    setModalStatus(status);

    // Busca el objeto de región correspondiente en regiones
    const selectedRegionObject = regiones.find((region) => region.dsRegion === regionId);

    if (selectedRegionObject) {
      setModalRegionIdSelect(selectedRegionObject.regionId); // Establece el regionId numérico correcto
      setSelectedRegion(selectedRegionObject.regionId); // Actualiza el estado selectedRegion
    }

    setModalFechaCreacion(fechaCreacion);
  };

  // Maneja el cambio en el campo "Nombre"
  const handleNombreChange = (e) => {
    const newName = e.target.value;
    setModalNombre(newName);
    if (newName.trim().length === 0) {
      setNombreError('El nombre no puede estar vacío.');
    } else if (newName.trim().length < 3) {
      setNombreError('El nombre debe tener al menos 3 caracteres.');
    } else {
      const textRegex = /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ\s]*$/;

      if (textRegex.test(newName)) {
        setNombreError('');
      } else {
        setNombreError('El texto contiene caracteres no permitidos.')
      }
    }
  };

  // Maneja el cambio en el estado de "Estatus"
  const handleStatusChange = async (entidadId) => {
    try {
      const updatedEntidad = entidades.find((entidad) => entidad.entidadId === entidadId);

      if (!updatedEntidad) {
        console.error('No se encontró la entidad para actualizar el estado.');
        return;
      }

      const newStatus = !updatedEntidad.status;

      const updatedEntidadData = {
        dsEntidad: updatedEntidad.dsEntidad,
        fechaCreacion: updatedEntidad.fechaCreacion,
        entidadId: updatedEntidad.entidadId,
        region: {
          regionId: updatedEntidad.region.regionId,
        },
        status: newStatus, // Establece el nuevo estado aquí
      };

      const url = `/ms-catalogos/filtros/entidad/`;

      const response = await clientAxios8080.put(url, updatedEntidadData);

      if (response.status === 200) {
        console.log('Entidad actualizada exitosamente.');

        // Actualizar el estado local para reflejar el nuevo estado
        const updatedEntidades = entidades.map((entidad) =>
          entidad.entidadId === entidadId ? { ...entidad, status: newStatus } : entidad
        );
        setEntidades(updatedEntidades);

        // Mostrar notificación según el nuevo estado
        const successMessage = newStatus ? 'Entidad activada exitosamente.' : 'Entidad desactivada exitosamente.';
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: successMessage,
          showConfirmButton: false,
          timer: 1200,
        });
      } else {
        console.error('Error al actualizar la entidad:', response.data.error);
      }
    } catch (error) {
      console.error('Error al enviar la solicitud PUT:', error);
    }
  };

  // Maneja el clic en el botón "Guardar"
  const handleGuardarClick = async () => {
    setLoading(true)
    let newNombreError = '';
    let newRegionIdError = '';
    if (modalNombre.trim().length === 0) {
      newNombreError = 'El nombre no puede estar vacío.';
    } else if (modalNombre.trim().length < 3) {
      newNombreError = 'El nombre debe tener al menos 3 caracteres.';
    }

    if (!modalRegionIdSelect) {
      // Verifica si no se ha seleccionado una región
      newRegionIdError = 'Por favor, seleccione una región.';
    }

    setNombreError(newNombreError);
    setRegionIdError(newRegionIdError);

    // Si no hay errores, guarda la entidad
    if (!newNombreError && !newRegionIdError) {
      if (modalEntidadId !== null) {
        // Actualizar entidad existente
        try {
          await putEntidad(); // Llama a la función para actualizar la entidad
          
          // Cerrar el modal y resetear los campos
          setIsModalOpen(false);
          setModalNombre('');
          setModalRegionIdSelect('');
          setSelectedRegion(''); // Establece selectedRegion a vacío
          if (modalNombre.trim().length >= 3) {
            setNombreError('');
          }
        } catch (error) {
          if (error.response && error.response.data && error.response.data.error) {
            console.error('Error al actualizar la entidad:', error.response.data.error);
          } else {
            console.error('Error al enviar la solicitud:', error);
          }
        }
      } else {
        // Agregar nueva entidad (Este bloque solo debe ejecutarse cuando no estás editando)
        try {
          // Asigna el valor seleccionado de modalRegionIdSelect a modalRegionId
          setModalRegionId(modalRegionIdSelect);

          await postEntidad(); // Llama a la función para crear una nueva entidad

          // Cerrar el modal y resetear los campos
          setIsModalOpen(false);
          setModalNombre('');
          setModalRegionIdSelect('');
          setSelectedRegion(''); // Establece selectedRegion a vacío
          if (modalNombre.trim().length >= 3) {
            setNombreError('');
          }
        } catch (error) {
          if (error.response && error.response.data && error.response.data.error) {
            console.error('Error al crear la entidad:', error.response.data.error);
          } else {
            console.error('Error al enviar la solicitud:', error);
          }
        }
      }
    }
  };

  /// Maneja el clic en el botón "Eliminar"
  const handleEliminarClick = (entidadId) => {
    const entidad = entidades.find((e) => e.entidadId === entidadId); // Encuentra la entidad por su ID

    Swal.fire({
      title: `Estás a punto de eliminar la entidad: "${entidad.dsEntidad}".`,
      text: 'Esta acción no se puede revertir.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Call the deleteRegion function to delete the entity
          await deleteEntidad(entidadId);

          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Registro eliminado con éxito.',
            showConfirmButton: false,
            timer: 1200,
          });
        } catch (error) {
          console.error('Error al eliminar el inmueble:', error);

          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error al eliminar el registro.',
            showConfirmButton: false,
            timer: 1200,
          });
        }
      }
    });
  };

  const compareById = (a, b) => {
    return a.entidadId - b.entidadId;
  };

  const handleSearchChange = (e) => {
    const searchTerm = e.target.value;
    setSearchValue(searchTerm);

    // Filtra los datos según el término de búsqueda
    filterEntidades(searchTerm);
  };

  const removeAccents = (str) => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  };
  const filterEntidades = useCallback(
    (searchTerm) => {
      if (searchTerm.trim() === '') {
        // Si el término de búsqueda está vacío, muestra todos los datos
        SetFilteredEntidades(entidades);
      } else {
        // Normaliza el término de búsqueda y los datos antes de comparar (ignorando mayúsculas/minúsculas)
        const normalizedSearchTerm = removeAccents(searchTerm.toLowerCase());
        const filteredData = entidades.filter((entidad) => {
          const normalizedDsEntidad = removeAccents(entidad.dsEntidad.toLowerCase());
          const normalizedDsRegion = removeAccents(entidad.region.dsRegion.toLowerCase());
          return normalizedDsEntidad.includes(normalizedSearchTerm) || normalizedDsRegion.includes(normalizedSearchTerm);
        });
        SetFilteredEntidades(filteredData);
      }
    },
    [entidades]
  );

  useEffect(() => {
    // Actualiza los resultados filtrados cuando cambia el estado de entidades o searchValue
    filterEntidades(searchValue);
  }, [entidades, searchValue, filterEntidades]);

  // Renderiza el componente
  return (
    <div className={classes.root}>
      <h1>Detalle del Catálogo para Entidades</h1>
      <div className={classes.filterAndButton}>
        <TextField
          className={classes.searchField}
          label="Buscar"
          variant="outlined"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          value={searchValue}
          onChange={handleSearchChange} // Manejar cambios en el campo de búsqueda
        />
        <Button variant="contained" color="success" className={classes.addButton} onClick={handleAgregarClick} startIcon={<AddIcon />}>
          Agregar Nuevo
        </Button>
      </div>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow className={classes.headerRow}>
              <TableCell align="center">Id</TableCell>
              <TableCell align="center">Nombre</TableCell>
              <TableCell align="center">Región</TableCell>
              <TableCell align="center">Fecha de Creación</TableCell>
              <TableCell align="center">Estatus</TableCell>
              <TableCell align="center">Editar</TableCell>
              <TableCell align="center">Eliminar</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredRegiones.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No se encontraron resultados.
                </TableCell>
              </TableRow>
            ) : (
              filteredRegiones.sort(compareById).map((entidad) => (
                <TableRow key={entidad.entidadId}>
                  <TableCell align="center">{entidad.entidadId}</TableCell>
                  <TableCell align="center">{entidad.dsEntidad}</TableCell>
                  <TableCell align="center">{entidad.region.dsRegion}</TableCell>
                  <TableCell align="center">{format(new Date(Number(entidad.fechaCreacion)), 'yyyy-MM-dd')}</TableCell>
                  <TableCell align="center">
                    <div className={classes.centeredSwitch}>
                      <Switch
                        checked={entidad.status}
                        onChange={() => handleStatusChange(entidad.entidadId)}
                        className={classes.customSwitch}
                      />
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    <div className={`${classes.imageButtonEditar} ${classes.imageButtonWithMargin}`}>
                      <img
                        src={editarImage}
                        alt="Editar"
                        className={`${classes.imageButtonEditar} ${classes.imageButtonWithMargin}`}
                        onClick={() =>
                          handleEditarClick(
                            entidad.entidadId,
                            entidad.dsEntidad,
                            entidad.status,
                            entidad.region.dsRegion,
                            entidad.fechaCreacion
                          )
                        }
                      />
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    <div className={`${classes.imageButtonEliminar} ${classes.imageButtonWithMargin}`}>
                      <img
                        src={eliminarImage}
                        alt="Eliminar"
                        className={`${classes.imageButtonEliminar} ${classes.imageButtonWithMargin}`}
                        onClick={() => handleEliminarClick(entidad.entidadId)}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {loading && <LoadingOverlay />}
      <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <Box sx={modalStyle}>
          <h2>{modalEntidadId !== null ? 'Editar Elemento' : 'Agregar nuevo elemento'}</h2>
          <TextField
            label="Nombre"
            variant="outlined"
            value={modalNombre}
            onChange={handleNombreChange}
            className={classes.modalTextField}
            error={nombreError !== ''}
            helperText={nombreError}
          />
          <FormControl variant="outlined" className={classes.modalTextField} error={Boolean(regionIdError)}>
            <InputLabel id="regionLabel" htmlFor="regionSelect" {...(regionIdError ? { style: { color: 'red' } } : {})}>
              Región
            </InputLabel>
            <Select
              labelId="regionLabel"
              id="regionSelect"
              label="Región"
              value={modalRegionIdSelect}
              onChange={(e) => setModalRegionIdSelect(e.target.value)}
            >
              {regiones.map((region) => (
                <MenuItem key={region.regionId} value={region.regionId}>
                  {region.dsRegion}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className={classes.errorText}>{regionIdError}</FormHelperText>
          </FormControl>

          <div className={classes.modalButtons}>
            <Button variant="contained" color="primary" onClick={handleGuardarClick} className={classes.guardarButton}>
              Guardar
            </Button>
            <Button variant="outlined" color="secondary" onClick={() => setIsModalOpen(false)} className={classes.cancelarButton}>
              Cancelar
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default EntidadDetalle;
